export var apiUrl = process.env.REACT_APP_API_URL;
export var urmUrl = process.env.REACT_URM_API_URL;
export var searchParamsAPI = ["title", "state", "sort", "open", "country"];
